<template>
    <div class="login-container">
        <div class="login-header">
           <div class="login"><img src="~@/assets/images/logo_pic.png"/></div>
        </div>
        <div class="login-body">
        <div class="form-box">
          <div class="form-left">
             <img src="~@/assets/images/login-adv.png" class="imgIcon"/>
          </div>
          <div class="form-right">
            <el-form autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="top"
                    class="card-box">
                <h3 class="title">{{$t("wm_lang_html_a552fc")}}</h3>
                <el-form-item prop="email" :label="$i18n.t('wm_lang_3bc5e6')">
                    <el-input name="email" type="text" v-model="loginForm.email" autoComplete="on" :placeholder="$i18n.t('wm_lang_dbf6d0')"></el-input>
                </el-form-item>
                <el-form-item prop="password" :label="$i18n.t('wm_lang_a81052')">
                    <el-input name="password" type="password" v-model="loginForm.password" autoComplete="on" :placeholder="$i18n.t('wm_lang_e39ffe')" show-password></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="loading" @click.native.prevent="handleLogin" class="loginBtn">
                      {{$t("custom_lang_0033")}}
                    </el-button>
                </el-form-item>
                <!-- <div class='tips'>{{$t("wm_lang_html_6e0780")}}</div> -->
            </el-form>
          </div>
        </div>
        </div>
        <div class="login-footer">
            <a @click="loginSSO">单点登录测试</a>
           <p>Copyright © 1998-{{currYear}} <el-link href="https://www.263.net/" target="_blank" class="pr-1">{{$t("wm_lang_html_2dc4ac")}}</el-link> </p>
        </div>
    </div>
</template>

<script>
    // import { mapGetters } from 'vuex';
    import Cookies from 'js-cookie';
    import xmail from '@/api/api';
    import storeLocal from 'store';
    import { isEmail } from '@/utils/validate';
    import { loginByEmail } from '@/api/login';
    import { rsaEncrypt } from '@/utils/utils';
    export default {
      components: { },
      name: 'login',
      data() {
        const validateEmail = (rule, value, callback) => {
          if (!isEmail(value)) {
            callback(new Error(this.$i18n.t('wm_lang_fb5158')));
          } else {
            callback();
          }
        };
        const validatePass = (rule, value, callback) => {
          if (value.length < 6) {
            callback(new Error(this.$i18n.t('wm_lang_0f43f5')+'6'+this.$i18n.t('wm_lang_cf10dc')));
          } else {
            callback();
          }
        };
        return {
          loginForm: {
            email: '',
            password: ''
          },
          loginRules: {
            email: [
                { required: true, trigger: 'blur', validator: validateEmail }
            ],
            password: [
                { required: true, trigger: 'blur', validator: validatePass }
            ]
          },
          currYear: '2022',
          loading: false,
          showDialog: false
        }
      },
      computed: {
        // ...mapGetters([
        //   'login_type'
        // ])
      },
      methods: {
        loginSSO() {
          Cookies.set('Pwm-userInfo-sso',{
            "sid": "f637bcab86a94e25b744089e798f8ba4",
            "userName": "na01",
            "userEmail": "na01@smail008.net",
            "primeUserEmail": "na01@smail008.net",
            "loginAppType": 2,
            "loginTokenType": 1,
            "logoutAddress": ""
          });
          window.location.href = window.location.protocol + "//" + window.location.host;
          console.log(Cookies.get('Pwm-userInfo-sso'));
        },
        handleLogin() {
          // storeLocal.remove('Pwm-Islogin');
          // storeLocal.remove('Pwm-user');
          // storeLocal.remove('Pwm-password');
          // Cookies.remove('Pwm-userInfo-sso');
          // // console.log(storeLocal)
          // storeLocal.set('Pwm-user',this.loginForm.email);
          // storeLocal.set('Pwm-password',rsaEncrypt(this.loginForm.password));
          // // this.$router.push({path: '/'});
          // let protocol = window.location.protocol;
          // let domain = window.location.host;
          // window.location.href = protocol + "//" + domain;


          this.$refs.loginForm.validate(valid => {
            if (valid) {
              storeLocal.remove('Pwm-Islogin');
              storeLocal.remove('Pwm-user');
              storeLocal.remove('Pwm-password');
              Cookies.remove('Pwm-userInfo-sso');
              // console.log(storeLocal)
              storeLocal.set('Pwm-user',this.loginForm.email);
              storeLocal.set('Pwm-password',rsaEncrypt(this.loginForm.password));
              // this.$router.push({path: '/'});
              let protocol = window.location.protocol;
              let domain = window.location.host;
              window.location.href = protocol + "//" + domain;
            } else {
              console.log('error submit!!');
              return false;
            }
          });

          // this.$refs.loginForm.validate(valid => {
          //   if (valid) {
          //     return new Promise((resolve, reject) => {
          //       loginByEmail(this.loginForm.email, rsaEncrypt(this.loginForm.password), xmail.enums.ClientType.WM_PC, true).then(response => {
          //         const data = response.data;
          //         // console.log(data);
          //         // return;
          //         if(data.code === 0) {
          //           storeLocal.set('Pwm-Islogin', data.data.sid);
          //           storeLocal.set('Pwm-userInfo', data.data);
          //           // storeLocal.set('Pwm-urlParams', '?sid='+ data.data.sid +'&loginAppType='+ data.data.loginAppType +'&user='+data.data.userEmail);
          //           // 后端请求的URL参数用主域名账号
          //           storeLocal.set('Pwm-urlParams', '?sid='+ data.data.sid +'&loginAppType='+ data.data.loginAppType +'&user='+data.data.primeUserEmail);
          //           this.$store.commit('SET_USER', data.data.userEmail);
          //           // this.$store.commit('SET_ISLOGIN', data.data.sid);
          //           // this.$store.commit('SET_USER', data.data.userEmail);
          //           // this.$store.commit('SET_SID', data.data.sid);
          //           // this.$store.commit('SET_LOGIN_TYPE', data.data.loginAppType);
          //           let self = this;
          //           (function (api, enums, pms) {
          //             api.Home.homeSetting({}, function (res) {
          //               if(res.data.code === 0) {
          //                 // console.log(res.data.data)
          //                 window.document.title = res.data.data.displaySetting.customTitle ? res.data.data.displaySetting.customTitle : this.$i18n.t('wm_lang_d7c0a1');
          //                 let configSetting = storeLocal.get('Pwm-configSetting');
          //                 if(configSetting) {//多语言强制刷新
          //                   if(res.data.data.displaySetting.language !== configSetting.displaySetting.language) {
          //                     let protocol = window.location.protocol;
          //                     let domain = window.location.host;
          //                     window.location.href = protocol + "//" + domain;
          //                   }
          //                 } else {
          //                   let protocol = window.location.protocol;
          //                   let domain = window.location.host;
          //                   window.location.href = protocol + "//" + domain;
          //                 }
          //                 storeLocal.set('Pwm-configSetting', res.data.data);
          //                 if(res.data.data.displaySetting.layout === enums.Layout.LR) {
          //                   Cookies.set('Pwm-set-layout','lr');
          //                 } else {
          //                   Cookies.set('Pwm-set-layout','tb');
          //                 }
          //                 //进首页
          //                 self.$router.push({ path: '/' });
          //               }
          //             })
          //           })(xmail.api, xmail.enums, xmail.pms);
          //           // this.$router.push({ path: '/' });
          //           this.loading = false;
          //         } else {
          //           let eCode = xmail.enums.ErrorCode;
          //           // console.log(data.code === xmail.enums.ErrorCode.WM_PASSWORD_WEAK_ERROR)
          //           if(data.code === eCode.WM_PASSWORD_WEAK_ERROR || data.code === eCode.UDR_USER_PASSWORD_WEAK_ERROR || data.code === eCode.UDR_USER_PASSWORD_FIRST_ERROR || data.code === eCode.UDR_USER_PASSWORD_CYCLE_ERROR) {
          //             storeLocal.set('Pwm-urlParams', '?sid='+ data.data.sid +'&loginAppType='+ data.data.loginAppType +'&user='+data.data.userEmail);
          //             storeLocal.set('Pwm-passwordRule', {...data.data.corpRulePasswd,...{pwType:data.code}});
          //             this.$router.push({name: 'ChangePw', params: { errorData: data}});
          //           } else {
          //             this.$router.push({name: 'Error', query: {code:data.code, host:data.host, time:data.time, traceId:data.traceId , webLanguage:data.data ? data.data.webLanguage : '' }});
          //           }
          //         }
          //         resolve();
          //       }).catch(error => {
          //         // this.$message.error(error);
          //         this.loading = false;
          //         console.log(error)
          //         reject(error);
          //       });
          //     });
          //
          //     // this.$store.dispatch('LoginByEmail', this.loginForm).then(() => {
          //     //   this.loading = false;
          //     //   this.$router.push({ path: '/' });
          //     //   // this.showDialog = true;
          //     // }).catch(err => {
          //     //   this.$message.error(err);
          //     //   this.loading = false;
          //     // });
          //
          //   } else {
          //     console.log('error submit!!');
          //     return false;
          //   }
          // });
        },
        keyupSubmit() {
          document.onkeyup = (e) => {
            let _key = window.event.keyCode;
            if (_key === 13) {
              this.handleLogin();
            }
          };
        }
      },
      mounted() {
        // console.log(this.$storeLocal)
        // let sdfsdf = '%7B%22sid%22%3A%22d0f6bc47cda942d9adc186629df92403%22%2C%22userName%22%3A%22test01%22%2C%22userEmail%22%3A%22test01%40dm002.net%22%2C%22primeUserEmail%22%3A%22test01%40dm002.net%22%2C%22loginAppType%22%3A16%2C%22loginTokenType%22%3A2%2C%22logoutAddress%22%3A%22%22%7D'
        // console.log(JSON.parse(decodeURIComponent(sdfsdf)));
        this.currYear = new Date().getFullYear();
      },
      created() {
        // window.addEventListener('hashchange', this.afterQRScan);
        this.keyupSubmit();
      },
      destroyed() {
        // window.removeEventListener('hashchange', this.afterQRScan);
      }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    @import "src/styles/mixin.scss";
    .tips{
      font-size: 14px;
      color: #858585;
      margin-bottom: 5px;
    }
    .login-container {
        // width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #3986EE;
        flex-wrap:wrap;
        overflow:hidden;
        input:-webkit-autofill {
            -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
            -webkit-text-fill-color: #fff !important;
        }
        input {
            background: transparent;
            border: 0px;
            -webkit-appearance: none;
            border-radius: 0px;
            padding: 12px 5px 12px 15px;
            color: #eeeeee;
            height: 47px;
        }
        .el-input {
            display: inline-block;
            height: 47px;
            width: 100%;
        }
        .svg-container {
            padding: 6px 5px 6px 15px;
            color: #889aa4;
        }

        .title {
            font-size: 24px;
            font-weight: 400;
            color: #2081eb;
            margin: 0px auto 40px auto;
            text-align: center;
            font-weight: bold;
        }

        .form-box {
          width: 60%;
          height: 100%;
          min-width: 1000px;
          margin:0 auto;
          border-radius: 4px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .form-left{
            width: 60%;
            padding: 30px;
            img{max-width:90%;margin-top:5%;}
          }
          .form-right{background: #FFFFFF; box-shadow: 0px 2px 18px 0px rgba(0,0,0,0.13); border-radius: 10px;width: 384px;max-height:380px;padding: 35px 40px;}
        }

        .el-form-item {
            border: 1px solid rgba(255, 255, 255, 0.1);
            /*background: rgba(0, 0, 0, 0.1);*/
            border-radius: 5px;
            color: #454545;
            /deep/ .el-form-item__label{color:#858585;font-size:16px;padding-bottom:0px;}
            /deep/ .el-form-item__label::before{display: none;}
        }
        .el-button {
          width: 100%;
        }
        .loginBtn{background: #1b77f0!important;font-size:18px;margin-top:20px;}
        .forget-pwd {
            color: #fff;
        }
        .login-header{
           height:78px;
           position: fixed;
           top:0;
           left:0;
           width:90%;
           background: #fff;
           padding:0 5%;
           flex-shrink:0;
           .login img{height:52px;padding-top:12px;}
        }
        .login-body{height: calc(100vh - 140px);width:100%;}
        .login-footer{
           background: #fff;
           height:62px;
           width:90%;
           padding: 0 5%;
           text-align:center;
           color:#fff;
           position:fixed;
           bottom:0;
           left:0;
           flex-shrink:0;
           p{padding-top:20px;color:#333;}
           a{color:#333;}
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/views/login/index.vue